import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _path;

const _excluded = ["size", "title", "titleId"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';

function CaretDown(_ref) {
  let {
    size: sizeProp,
    title,
    titleId
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54 10h6.92c.48 0 .72.639.381 1.012l-3.46 3.814a.504.504 0 01-.761 0l-3.461-3.814c-.34-.373-.1-1.012.38-1.012z"
  })));
}

CaretDown.sizes = sizes;
CaretDown.defaultProps = {
  size: sizes.md
};
CaretDown.propTypes = {
  size: PropTypes.oneOf([CaretDown.sizes.xs, CaretDown.sizes.sm, CaretDown.sizes.md, CaretDown.sizes.lg, CaretDown.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default CaretDown;